import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Cookies from 'universal-cookie'

import { useUserSession } from 'hooks'
import redirect from 'lib/universal-redirect'
import { cookieDomain } from 'lib/cookie-domain'

import { formattedStats } from 'constants/marketing-stats'
import FetchingPanel from 'components/FetchingPanel'
import BasePage from 'modules/marketplace/layout/components/BasePage'
import SignupUserForm from 'modules/signup/components/SignupUserForm'
import SignupUserContainer from 'modules/signup/components/SignupUserContainer'
import MarketingSignupHero from 'modules/signup/components/MarketingSignupHero'
import AuthContainer from 'modules/auth/components/AuthContainer'
import { UserSignupSourceEnum } from '../../../../../__generated__/globalTypes'

const SignupBuyerPage = () => {
  const [isLoading, setIsLoading] = useState(true)
  const router = useRouter()
  const { isGuest, sessionLoading, accounts, currentUser, redirectBySignupSource } = useUserSession()

  let signupSource = UserSignupSourceEnum.BUYER
  if (router.query?.source === UserSignupSourceEnum.BUYER_INVITE) {
    signupSource = UserSignupSourceEnum.BUYER_INVITE
  }

  useEffect(() => {
    const loadData = async () => {
      if (!router.isReady || sessionLoading) return

      // NOTE: not using withGuestPage as this causes redirection issues?
      if (!isGuest) {
        if ((accounts?.length || 0) >= 1) {
          redirect({ href: '/' })
        } else {
          redirectBySignupSource(currentUser)
        }

        return
      }

      setIsLoading(false)

      // Store the returnTo in a cookie, so we don't loose it during the signup process
      if (router.query.returnTo) {
        const cookies = new Cookies()
        cookies.set('returnTo', router.query.returnTo, { path: '/', domain: cookieDomain() })
      }
    }

    loadData()
  }, [
    accounts?.length,
    currentUser,
    isGuest,
    redirectBySignupSource,
    router.isReady,
    router.query.returnTo,
    sessionLoading
  ])

  return (
    <BasePage hasHeader={false} hasFooter={false}>
      <Head>
        <title>Buyer Signup · Fieldfolio</title>
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/signup/buyer`} />
      </Head>

      <SignupUserContainer
        leftContent={
          <MarketingSignupHero
            imageUrl="/marketing/signup/buyer.jpg"
            heading="Your one-stop shop for buying wholesale"
            subheading={`Join ${formattedStats.buyers}+ buyers and shop over ${formattedStats.products} products from thousands of wholesalers, all in one place.`}
          />
        }
        rightContent={
          <AuthContainer
            heading="Buyer Signup"
            headingId="signup-heading"
            progressPercent={25}
            centered
            caption={
              <>
                A Buyer account is for retailers and other businesses that want to purchase products from wholesalers.
              </>
            }>
            <>
              {isLoading && <FetchingPanel />}
              {!isLoading && (
                <SignupUserForm signupSource={signupSource} onSignupSuccess={() => router.push('/verify')} />
              )}
            </>
          </AuthContainer>
        }
      />
    </BasePage>
  )
}

export default SignupBuyerPage
